module.exports = __webpack_public_path__ + "img/icon-linkedin.b950987f.svg";